import { Box, Button, Paper, Typography } from '@material-ui/core'
import useFeatureAccessGuard from 'hooks/useFeatureAccessGuard'
import useTeamFeature from 'hooks/useTeamFeature'
import { SubLink } from 'containers'
import React from 'react'
import { connect } from 'react-redux'
import { articles as articlesModule } from 'redux/modules'
import { Translate } from 'react-localize-redux'
import LockIconComponent from 'components/UpgradeMembership/LockIconComponent'
import usePermission from 'hooks/usePermission'
import ArticlesContainer from './components/ArticlesContainer'
import TEAM_FEATURE_FLAGS from 'constants/teamFeatureFlags'
import { ARTICLE_CREATE_ROUTE, ARTICLES_CATEGORIES } from 'constants/routes'
import PERMISSIONS from 'constants/permissions'

const ArticlesDashboard = () => {
  const featureGuard = useFeatureAccessGuard()
  const { enabled: hasCreateContentEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.create_knowledge_enabled
  )
  const canUpdateClub = usePermission(PERMISSIONS.UPDATE_CLUB, 'club')

  return (
    <>
      <Paper
        component={Box}
        elevation={0}
        style={{
          padding: '17px 30px 30px 30px',
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          flexDirection={{ xs: 'column', sm: 'row' }}
          gridGap={{ xs: 16, sm: 8 }}
        >
          <Typography variant="h3">
            <Translate id="articles.articles" />
          </Typography>
          <Box display="flex" gridGap={8}>
            {canUpdateClub && (
              <Button
                variant="contained"
                color="primary"
                component={SubLink}
                to={ARTICLES_CATEGORIES}
              >
                <Translate id="articles.manage-categories" />
              </Button>
            )}
            <Button
              variant="contained"
              color="primary"
              {...(!hasCreateContentEnabled
                ? {
                    onClick: () => featureGuard(),
                  }
                : {
                    component: SubLink,
                    to: ARTICLE_CREATE_ROUTE,
                  })}
              endIcon={
                !hasCreateContentEnabled ? (
                  <LockIconComponent context="primaryButton" />
                ) : null
              }
            >
              <Translate id="articles.create-content" />
            </Button>
          </Box>
        </Box>
        <ArticlesContainer />
      </Paper>
    </>
  )
}

ArticlesDashboard.propTypes = {}

export default connect(
  ({ articles }) => ({
    article: articles.current,
  }),
  {
    deleteArticle: articlesModule.deleteArticle,
  }
)(ArticlesDashboard)
